import { GetOperatorOptionsType, operatorTypes, STRING_OPERATOR_OPTIONS } from 'core/table/interfaces/Filters'

export const DAILY_EVENTS_INCLUDES = 'dailyEventsIncludes'
export const DAILY_EVENTS_REGISTRATIONS = 'dailyEventsRegistrations'

export const REGISTRATION_OPERATOR_OPTIONS = [
  { value: operatorTypes.LESS_THAN, displayValue: 'Less than' },
  { value: operatorTypes.LESS_OR_EQUAL, displayValue: 'Less than or equal to' },
  { value: operatorTypes.GREATER_THAN, displayValue: 'Greater than' },
  { value: operatorTypes.GREATER_OR_EQUAL, displayValue: 'Greater than or equal to' },
]

export const INCLUDES_OPERATOR_OPTIONS = [
  { value: operatorTypes.ANY_OF, displayValue: 'Includes' },
  { value: operatorTypes.NOT_ANY_OF, displayValue: 'Does not include' },
]

export const DAY_OF_WEEK_OPTIONS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

const includesOperatorToMethodMap = {
  anyOf: (rowValue: string, operand: string[]) => !!rowValue && operand.includes(rowValue),
  notAnyOf: (rowValue: string, operand: string[]) => !rowValue || !operand.includes(rowValue),
}

const registrationOperatorToMethodMap = {
  '>=': (rowValue: number, operand: number) => rowValue >= operand,
  '>': (rowValue: number, operand: number) => rowValue > operand,
  '<': (rowValue: number, operand: number) => rowValue < operand,
  '<=': (rowValue: number, operand: number) => rowValue <= operand,
}

export const dailyEventsIncludesFilter = (
  rows: any[],
  ids: any[],
  filterValue: { operand: string[]; operator: string },
) => {
  const filterMethod = includesOperatorToMethodMap[filterValue.operator as keyof typeof includesOperatorToMethodMap]
  if (typeof filterMethod !== 'function') {
    return rows
  }

  return rows.filter(row =>
    ids.some(id => {
      const rowValue = row.values[id]
      return filterMethod(rowValue, filterValue.operand)
    }),
  )
}

export const dailyEventsRegistrationsFilter = (
  rows: any[],
  ids: any[],
  filterValue: { operand: string | number; operator: string },
) => {
  const filterMethod =
    registrationOperatorToMethodMap[filterValue.operator as keyof typeof registrationOperatorToMethodMap]
  if (typeof filterMethod !== 'function') {
    return rows
  }

  const operand = Number(filterValue.operand)

  return rows.filter(row =>
    ids.some(id => {
      const registrations = row.values[id]
      const rowValue = typeof registrations === 'object' ? registrations?.confirmed : registrations
      return filterMethod(Number(rowValue), operand)
    }),
  )
}

export const DAILY_EVENTS_FILTERS = {
  [DAILY_EVENTS_INCLUDES]: dailyEventsIncludesFilter,
  [DAILY_EVENTS_REGISTRATIONS]: dailyEventsRegistrationsFilter,
}

export const getDailyEventsOperatorOptions: GetOperatorOptionsType = column => {
  switch (column) {
    case 'name':
      return STRING_OPERATOR_OPTIONS
    case 'role':
    case 'day':
      return INCLUDES_OPERATOR_OPTIONS
    case 'registrations':
      return REGISTRATION_OPERATOR_OPTIONS
    default:
      return []
  }
}
